import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function BackupAlertBanner() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [a, setA] = useState(null);
  const allowed = can("ayarlar");
  useEffect(() => { if (allowed) api.get("/backup/alert").then(({ data }) => setA(data)).catch(() => {}); }, [allowed]);
  if (!a?.message) return null;
  return (
    <button type="button" onClick={() => nav("/ayarlar?tab=backup")} data-testid="dashboard-backup-alert"
      className="w-full mb-4 flex items-center gap-2 rounded-md border border-rose-400 bg-rose-600 px-4 py-3 text-left text-[13px] font-semibold text-white hover:bg-rose-700 transition-colors">
      <AlertTriangle className="h-5 w-5 shrink-0" />
      <span data-testid="dashboard-backup-alert-text">{a.message}</span>
      {a.stats && <span className="ml-auto text-[11px] font-normal opacity-90 whitespace-nowrap" data-testid="dashboard-backup-alert-stats">{a.stats.label}</span>}
    </button>
  );
}
